








import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import DialogHead from '../DialogHead/index.vue'
import DialogFooter from '../DialogFooter/index.vue'
@Component({
  components: {
    DialogHead,
    DialogFooter
  }
})
export default class DialogMain extends Vue {
  @Prop() title!: string
  @Prop() dialogVisible!: (string | boolean)
}
